export default "__VITE_ASSET__BYi$VvDY__"